if (!customElements.get('slynara-hero-carousel')) {
  customElements.define(
    'slynara-hero-carousel',
    class SlynaraHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slynara-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-slynara-hero-dot]'));
        this.previousButton = this.querySelector('[data-slynara-hero-previous]');
        this.nextButton = this.querySelector('[data-slynara-hero-next]');
        this.autoplayButton = this.querySelector('[data-slynara-hero-autoplay]');
        this.autoplayLabel = this.querySelector('[data-slynara-hero-autoplay-label]');
        this.status = this.querySelector('[data-slynara-hero-status]');
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.autoplayPausedByUser = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (this.slides.length < 2) return;

        this.previousButton?.addEventListener('click', () => this.show(this.currentIndex - 1, true));
        this.nextButton?.addEventListener('click', () => this.show(this.currentIndex + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.slynaraHeroDot), true)));
        this.autoplayButton?.addEventListener('click', () => this.toggleAutoplay());
        this.addEventListener('keydown', (event) => this.onKeydown(event));
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.play();
        });
        this.addEventListener('touchstart', (event) => this.onTouchStart(event), { passive: true });
        this.addEventListener('touchend', (event) => this.onTouchEnd(event), { passive: true });
        this.reducedMotion.addEventListener('change', () => this.play());

        this.editorSelectHandler = (event) => {
          const slide = event.target.closest('[data-slynara-hero-slide]');
          if (slide) this.show(this.slides.indexOf(slide), false);
        };
        document.addEventListener('shopify:block:select', this.editorSelectHandler);
        this.play();
      }

      disconnectedCallback() {
        this.pause();
        document.removeEventListener('shopify:block:select', this.editorSelectHandler);
      }

      show(index, announce = false) {
        this.currentIndex = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          active ? slide.removeAttribute('inert') : slide.setAttribute('inert', '');
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.currentIndex;
          dot.classList.toggle('is-active', active);
          active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current');
        });
        if (announce && this.status) this.status.textContent = `Slide ${this.currentIndex + 1} of ${this.slides.length}`;
        this.play();
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') this.show(this.currentIndex - 1, true);
        else if (event.key === 'ArrowRight') this.show(this.currentIndex + 1, true);
        else if (event.key === 'Home') this.show(0, true);
        else if (event.key === 'End') this.show(this.slides.length - 1, true);
        else return;
        event.preventDefault();
      }

      onTouchStart(event) {
        this.touchStartX = event.changedTouches[0].clientX;
      }

      onTouchEnd(event) {
        if (this.touchStartX === undefined) return;
        const distance = event.changedTouches[0].clientX - this.touchStartX;
        this.touchStartX = undefined;
        if (Math.abs(distance) < 50) return;
        this.show(this.currentIndex + (distance < 0 ? 1 : -1), true);
      }

      toggleAutoplay() {
        this.autoplayPausedByUser = !this.autoplayPausedByUser;
        this.autoplayPausedByUser ? this.pause() : this.play();
        this.autoplayButton?.setAttribute('aria-label', this.autoplayPausedByUser ? 'Play carousel' : 'Pause carousel');
        if (this.autoplayLabel) this.autoplayLabel.textContent = this.autoplayPausedByUser ? 'Play' : 'Pause';
      }

      play() {
        this.pause();
        if (!this.autoplayEnabled || this.autoplayPausedByUser || this.reducedMotion.matches || this.matches(':hover') || this.contains(document.activeElement)) return;
        this.timer = window.setInterval(() => this.show(this.currentIndex + 1), Number(this.dataset.speed) || 6000);
      }

      pause() {
        window.clearInterval(this.timer);
      }
    }
  );
}
